export default "__VITE_ASSET__CNVdCiMF__"